import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { DataService } from "../../core/services/data.service";
import { NotificationService } from "../../core/services/notification.service";
import { ServiceItem, ServiceRequestTypeItem } from "../models/services/service-item";
import { Observable } from "rxjs";
import { ActionDataResult } from "../models/core/ActionDataResult";

@Injectable()
export class CategoryServicesService extends DataService<ServiceItem, ServiceItem> {

	constructor(
		protected http: HttpClient,
		protected notificationService: NotificationService) {
    super(http, notificationService);

    this.controllerName = 'services';
  }

  getAllServiceRequestTypes(): Observable<ServiceRequestTypeItem[]> {
      return this.getQuery<ServiceRequestTypeItem[]>(`${this.baseUrl()}/service-request-types`)
  }
}
